import React, { ReactElement } from "react";
import { isMobile } from "react-device-detect";
import { useSelector } from "react-redux";
import Modal from "react-responsive-modal";
import StoreType from "../interfaces/StoreType";
import UseCookies from "../ressources/UseCookies";
import CookiesMain from "./CookiesMain";
import CookiesSettings from "./CookiesSettings";

export default function Cookies(): ReactElement {
  const { isTCValidated } = useSelector((state: StoreType) => ({
    ...state.RouterReducer,
  }));
  const {
    closeCookies,
    isAdds,
    isSettings,
    isSocialNetwork,
    isMoreInformations,
    setIsAdds,
    setIsMoreInformations,
    setIsSettings,
    setIsSocialNetwork,
  } = UseCookies();

  return (
    <Modal
      blockScroll={true}
      open={!isTCValidated}
      onClose={() => closeCookies(isAdds, isSocialNetwork)}
      classNames={{
        modalContainer: "cookies-background-modale popup-cookie-banner",
        modal: "cookies-container popup-cookie-banner",
        closeIcon: "exit",
        closeButton: "exit",
        overlay: "background popup-cookie-background",
      }}
      styles={{
        modal: {
          height:
            isMobile && isSettings
              ? "100%"
              : !isMobile
              ? "min-content"
              : "auto",
        },
      }}
      closeOnOverlayClick={false}
      center={isMobile ? false : true}
      closeIcon={false}
      showCloseIcon={false}
    >
      {isSettings ? (
        <CookiesSettings
          setIsAdds={setIsAdds}
          setIsSettings={setIsSettings}
          setIsSocialNetwork={setIsSocialNetwork}
          closeCookies={closeCookies}
          isAdds={isAdds}
          isMoreInformations={isMoreInformations}
          isSocialNetwork={isSocialNetwork}
          setIsMoreInformations={setIsMoreInformations}
        />
      ) : (
        <CookiesMain
          setIsAdds={setIsAdds}
          setIsSettings={setIsSettings}
          setIsSocialNetwork={setIsSocialNetwork}
          closeCookies={closeCookies}
        />
      )}
    </Modal>
  );
}
